import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";
import { successNotification } from "../../utils/notifications";

interface State {
  searching: boolean;
  saving: boolean;
  validationResult: any;
  processingResult: any;
}

const initialState: State = {
  searching: false,
  saving: false,
  validationResult: null,
  processingResult: null
};

export default function productosCargaMasivaReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(
  state: State = initialState,
  action: IAction
): Partial<State> {
  switch (action.type) {
    case `${actionTypes.POST_VALIDAR_PRODUCTOS_CARGA_MASIVA}_PENDING`: {
      return {
        ...state,
        searching: true
      };
    }

    case `${actionTypes.POST_VALIDAR_PRODUCTOS_CARGA_MASIVA}_REJECTED`: {
      return {
        ...state,
        searching: false
      };
    }

    case `${actionTypes.POST_VALIDAR_PRODUCTOS_CARGA_MASIVA}_FULFILLED`: {
      let validationResult;

      if (action.payload && action.payload.data) {
        validationResult = action.payload.data;
      } else {
        validationResult = action.payload;
      }

      if (
        validationResult &&
        (validationResult.valid || validationResult.isValid)
      ) {
        successNotification("Archivo validado correctamente");
      }

      return {
        ...state,
        searching: false,
        validationResult
      };
    }

    case `${actionTypes.POST_PROCESAR_PRODUCTOS_CARGA_MASIVA}_PENDING`: {
      return {
        ...state,
        saving: true
      };
    }

    case `${actionTypes.POST_PROCESAR_PRODUCTOS_CARGA_MASIVA}_REJECTED`: {
      return {
        ...state,
        saving: false
      };
    }

    case `${actionTypes.POST_PROCESAR_PRODUCTOS_CARGA_MASIVA}_FULFILLED`: {
      successNotification("Productos procesados correctamente");

      let processingResult;

      if (action.payload && action.payload.data) {
        processingResult = action.payload.data;
      } else {
        processingResult = action.payload;
      }

      return {
        ...state,
        saving: false,
        processingResult,
        validationResult: null
      };
    }

    default: {
      return state;
    }
  }
}
